import { render, staticRenderFns } from "./TotalService.vue?vue&type=template&id=9010d52c&"
import script from "./TotalService.vue?vue&type=script&lang=js&"
export * from "./TotalService.vue?vue&type=script&lang=js&"
import style0 from "./TotalService.vue?vue&type=style&index=0&id=9010d52c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports